import React from 'react';

import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { closeIntercomConnection } from '../../../utils/intercom';
import { removeToken } from '../../../utils/token';

import { logout } from '../../auth/utils/loginSlice';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

const LogoutModal = ({ show, handleClose }) => {
  const { t } = useTranslation(['title', 'description', 'button']);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    queryClient.clear();
    removeToken();
    localStorage.removeItem('clouderType');
    closeIntercomConnection();
    dispatch(logout());
    handleClose();
    navigate('/login');
  };

  return (
    <Modal
      aria-labelledby="logout-modal"
      centered
      show={show}
      onHide={handleClose}
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="logout-modal">
          {t('logout', { ns: 'title' })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('logout', { ns: 'description' })}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleLogout}>
          {t('logout', { ns: 'button' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutModal;
